import type { WorkbookDefinition } from '@erp/shared-types';
import { shareUnchanged } from './workbookProcessChanges';
export interface WorkbookEditorState {
  definition: WorkbookDefinition;
  revision: number;
  editVersion: number;
  savedEditVersion: number;
}

export function restoredEditorState(
  state: WorkbookEditorState,
  restored: { definition: WorkbookDefinition; revision: number },
  editAtStart: number,
): WorkbookEditorState {
  // Preserve an edit made during the request, but save it against the restored revision.
  if (state.editVersion !== editAtStart)
    return { ...state, revision: restored.revision };
  return {
    // Unchanged items keep their identity, so memoized views of them survive the restore.
    definition: shareUnchanged(state.definition, restored.definition),
    revision: restored.revision,
    editVersion: state.editVersion + 1,
    savedEditVersion: state.editVersion + 1,
  };
}
